// Module
var code = "<select class=\"needletail-sort-select\"> {{#options}} <option value=\"{{ name }}\" data-attribute=\"{{ attribute }}\" data-direction=\"{{ direction }}\">{{#display_name}}{{{ display_name }}}{{/display_name}}{{^display_name}}{{ name }}{{/display_name}}</option> {{/options}} </select>";
// Exports
export default code;